import { Behavoir, configureBindings } from "@eusoft/webapp-core";
import type { ITemplateContext } from "@eusoft/webapp-core";

export interface ISteadyClickOptions {

    handler: (ev: PointerEvent) => void;
}

export class SteadyClick extends Behavoir<ISteadyClickOptions>{

    attach(ctx: ITemplateContext<this, HTMLDivElement>): void {

        const downPos = { x: 0, y: 0 }

        const el = ctx.element.parentNode as HTMLDivElement;

        el.addEventListener("pointerdown", ev => {
            downPos.x = ev.screenX;
            downPos.y = ev.screenY;
        });

        el.addEventListener("pointerup", ev => {
            const dist = Math.sqrt(Math.pow(ev.screenX - downPos.x, 2) + Math.pow(ev.screenY - downPos.y, 2));
            if (dist < 10)
                this.handler(ev);
        });
    }

    handler: (ev: PointerEvent) => void;
}

configureBindings(SteadyClick, {
    "handler": "action"
});
